import { css } from "@emotion/css"

import Anchor from "@p-ban/common/src/components/html/Anchor"

const FooterNav = () => {
  return (
    <nav>
      <ul className={navStyle}>
        <li>
          <Anchor href="/corporate/company/companyinfo.html">会社概要</Anchor>
        </li>
        <li>
          <Anchor href="/others/about_pban.html">初めてのお客様へ</Anchor>
        </li>
        <li>
          <Anchor href="/others/privacy_policy.html">プライバシーポリシー</Anchor>
        </li>
        <li>
          <Anchor href="/others/linkpolicy.html">リンクについて</Anchor>
        </li>
        <li>
          <Anchor href="/information/tradelaw.html">特定商取引法に基づく表示</Anchor>
        </li>
        <li>
          <Anchor href="/others/sitemap.html">サイトマップ</Anchor>
        </li>
      </ul>
    </nav>
  )
}

export default FooterNav

const navStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 41px;
  list-style: none;
  border-top: 1px solid #238c26;
  > li {
    &:not(:first-child) {
      border-left: 1px solid #fff;
    }
    height: 12px;
    padding: 0 10px;
    > a {
      display: block;
      height: 11px;
      font-size: 11px;
      line-height: 13px;
      color: #fff;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
`
